import React from "react";

const ITEMS = [
  "Landed Curation",
  "24 Landed Districts",
  "Buy with Clarity",
  "Sell with Strategy",
  "Freehold Expertise",
  "The Annual Landed Exhibition",
  "20+ Years of Craft",
];

const Diamond = () => (
  <svg viewBox="0 0 10 10" className="mx-8 h-2 w-2 shrink-0 self-center" aria-hidden="true">
    <rect x="2" y="2" width="6" height="6" transform="rotate(45 5 5)" fill="#D4AF37" />
  </svg>
);

export const Marquee = () => {
  const row = (ariaHidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
      {ITEMS.map((item) => (
        <span key={item + (ariaHidden ? "-b" : "-a")} className="flex items-center whitespace-nowrap">
          <span className="font-serif text-xl italic text-ivory/90 sm:text-2xl">{item}</span>
          <Diamond />
        </span>
      ))}
    </div>
  );

  return (
    <div
      className="marquee-paused relative overflow-hidden border-y border-ivory/15 bg-charcoal py-5"
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee flex w-max">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
};
